import React from 'react';
import { css, createGlobalStyle } from 'styled-components';

export interface Font {
    fontFamily: string;
    fontStyle: 'normal' | 'italic';
    fontWeight: number | 'normal' | 'bold';
    woff2Url: string;
}

/* WOFF2: Chrome 26+, Opera 23+, Firefox 39+ */
export const getSrc = ({ woff2 }: { woff2: string }): string =>
    `url('${woff2}') format('woff2')`;

const getFontFace = (
    { fontFamily, woff2Url, fontStyle = 'normal', fontWeight = 'normal' }: Font,
    preventFallbackFont?: boolean,
): ReturnType<typeof css> => css`
    @font-face {
        /* stylelint-disable at-rule-descriptor-value-no-unknown */
        font-family: ${fontFamily};
        font-style: ${fontStyle};
        font-weight: ${fontWeight ? String(fontWeight) : 'normal'};
        src: ${getSrc({ woff2: woff2Url })};
        font-display: ${preventFallbackFont ? 'block' : 'swap'};
        /* stylelint-enable at-rule-descriptor-value-no-unknown */
    }
`;

interface FontFaceProps {
    fonts: Font[];
    preventFallbackFont?: boolean;
}

const getFontFaceStack = (props: FontFaceProps): ReturnType<typeof css> =>
    props.fonts.map(
        (font: Font): ReturnType<typeof css> =>
            getFontFace(font, props.preventFallbackFont),
    );

const FontFace = createGlobalStyle<FontFaceProps>`${(
    props,
): ReturnType<typeof css> => getFontFaceStack(props)}`;

export default React.memo(FontFace);
